import React, { useState, useEffect, useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { SessionContext } from '../profile_sheets/information_disclosures/application'
import LazyImg from 'javascripts/common/LazyImg'
import FavoriteIcon from 'images/favorite_job_offers/favorite_job_offers.svg'
import BookmarkIcon from 'images/job_offers/searching_bookmarks/icon_search.svg'
import HistoryIcon from 'images/job_offers/application_histories/icon_paper_airplane.svg'
import * as Routes from 'routes'
import styles from './JobOfferSideNav.module.scss'

type JobOfferSideNavProps = {
  notice?: boolean
}

const JobOfferSideNav: React.FC<JobOfferSideNavProps> = (props) => {
  const session = useContext(SessionContext)
  const login = !!session?.user
  const [notice, setNotice] = useState<boolean>(props.notice ?? true)

  useEffect(() => {
    if (localStorage.getItem('visited03')) {
      setNotice(false)
    }
    else {
      localStorage.setItem('visited03', '1')
      setNotice(true)
    }
  }, [])

  const renderApplicationHistory = () => {
    if (!login) return null

    return (
      <a
        href={Routes.job_offers_application_histories_path()}
        id='ga-application-histories'
        className={styles.sidenavItem}
        data-turbo='false'
      >
        <span className={styles.hoverItem}>応募履歴</span>
        <LazyImg className={styles.imgItem} src={HistoryIcon} />
      </a>
    )
  }

  const renderNotice = () => {
    if (!notice) return null

    const msg = <span>お気に入りの機能を使って、より便利にお仕事探しができます。</span>
    const loginMsg = <span>お気に入り、検索条件の保存、応募履歴の機能を<br />使って、より便利にお仕事探しができます。</span>

    return (
      <div className={`${styles.notice} ${!login ? styles.noticeF : ''}`}>
        <div className={styles.modalDialog}>
          <div className={styles.modalContent}>
            <button className={styles.noticeModalClose} type='button' data-bs-dismiss='modal' area-label='Close' onClick={() => setNotice(false)}>
              <FontAwesomeIcon icon={['fas', 'times']} />
            </button>
            <div className={styles.noticeModalText}>
              {login ? loginMsg : msg}
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      {renderNotice()}
      <div className={`job-offers-sidenav d-none d-lg-block ${styles.jobOffersSidenav}`}>
        <a
          href={Routes.favorite_job_offers_path()}
          id='ga-favorite-job-offers'
          className={styles.sidenavItem}
          data-turbo='false'
        >
          <span className={styles.hoverItem}>気になったお仕事</span>
          <LazyImg className={styles.imgItem} src={FavoriteIcon} />
        </a>
        <a
          href={Routes.searching_bookmarks_path()}
          id='ga-searching-bookmarks'
          className={styles.sidenavItem}
          data-turbo='false'
        >
          <span className={styles.hoverItem}>保存した条件</span>
          <LazyImg className={styles.imgItem} src={BookmarkIcon} />
        </a>
        {renderApplicationHistory()}
      </div>
    </>
  )
}

export default JobOfferSideNav
